import React, { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { addToGroups, clearGroups } from "../../redux/postSlice"; // ✅ FIX: import clearGroups

import useLoggedIn from "../../hooks/useLoggedIn";
import MyAvatar from "@components/admin/MyAvatar";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  textGrey: {
    color: "#626262",
  },
  bgGrey: {
    backgroundColor: "#efefef",
  },
  colorGreen: {
    backgroundColor: "#e5f8f1",
  },
}));

function SelectGroup({ groups, singleSelect = false }) {
  // ✅ FIX: accept singleSelect prop
  useLoggedIn();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { selectedGroups } = useSelector((state) => state.post);

  const [groupsToShow, setGroupsToShow] = useState([]);

  const isSelected = (id) => {
    // compare as strings to avoid type-mismatch between stored ids and group.id
    try {
      const sel = (selectedGroups || []).map((s) => String(s));
      return sel.includes(String(id));
    } catch (e) {
      return (selectedGroups || []).includes(id);
    }
  };;

  const handleSelectGroup = (group) => {
    if (singleSelect) {
      // ✅ FIX: regular post — only one group allowed at a time
      // If already selected, deselect it; otherwise clear and select the new one
      if (isSelected(group.id)) {
        dispatch(clearGroups());
      } else {
        dispatch(clearGroups());
        dispatch(addToGroups(group.id));
      }
    } else {
      // Event post — toggle (multi-select)
      dispatch(addToGroups(group.id));
    }
  };

  useEffect(() => {
    if (groups) {
      setGroupsToShow([...groups]);
    }
  }, [groups]);

  return (
    <div>
      <div className='flex flex-col mt-2 mx-6 gap-2'>
        <div className='max-h-[150px] overflow-y-auto flex flex-col gap-2'>
          {groupsToShow?.map((group, key) => (
            <div key={key} className='flex justify-between'>
              <MyAvatar
                src={group.icon?.currBucketUrl}
                name={group.name}
                avatarSx={{ width: 30, height: 30, fontSize: 16 }}
                textProps={{ style: { fontSize: 14 } }}
              />
              <label className={clsx(classes.textGrey)}>
                <Checkbox
                  className='py-1'
                  sx={{ color: "green" }}
                  checked={isSelected(group.id)}
                  onChange={() => handleSelectGroup(group)}
                />
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SelectGroup;
